import { render, staticRenderFns } from "./FirstLoginForm.vue?vue&type=template&id=65069d7c&scoped=true&"
import script from "./FirstLoginForm.vue?vue&type=script&lang=js&"
export * from "./FirstLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./FirstLoginForm.vue?vue&type=style&index=0&id=65069d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65069d7c",
  null
  
)

export default component.exports